import { AfterViewInit, ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { CommonMessageWidget } from '@eforall/common';
import { SelectEvent, TabStripModule } from '@progress/kendo-angular-layout';
import { environment } from '../../../../environments';
import { NotesEditorPart } from '../../notes-editor-dialog';
import { PersonDialogDataService, ViewModePersonTab } from '../person-dialog-data.service';
import { PersonEngagementsPart } from './person-engagements/person-engagements.part';
import { PersonOverviewPart } from './person-overview/person-overview.part';

@Component({
	selector: 'person-explorer-view-part',
	standalone: true,
	imports: [
		TabStripModule,
		PersonOverviewPart,
		PersonEngagementsPart,
		NotesEditorPart,
		CommonMessageWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-explorer.part.html'
})

export class PersonExplorerViewPart implements OnInit, AfterViewInit {

	public personId = input.required<number>();
	public dialogBodyHeight = input.required<number>();

	public personDialogDataService = inject(PersonDialogDataService);

	selectedTab = signal(0);
	public isNotProdEnvironment = environment.name !== 'PROD';

	async ngOnInit() {
		// Clear cached person details before fetching new data
		this.personDialogDataService.personDetails.set(undefined);
		this.personDialogDataService.getPersonDetails(this.personId(), false);
	}

	ngAfterViewInit() {
		const viewModePersonTab = this.personDialogDataService.viewModePersonTab();
		if (viewModePersonTab) {
			let tabIndex = 0; // Overview tab
			if (viewModePersonTab === 'engagements') {
				tabIndex = 1; // Engagements tab
			} else if (viewModePersonTab === 'notes') {
				tabIndex = 2; // Notes tab
			}
			this.selectedTab.set(tabIndex);
		}
	}

	private readonly TAB_INDEX_MAP: Record<number, ViewModePersonTab> = {
		0: 'overview',
		1: 'engagements',
		2: 'notes',
	};

	selectTab(event: SelectEvent) {
		this.selectedTab.set(event.index);
		const tab = this.TAB_INDEX_MAP[event.index] ?? 'overview';
		this.personDialogDataService.viewModePersonTab.set(tab);
	}

}